var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal",
      attrs: {
        id: "report-content-modal",
        title: _vm.$t("common.modal.report_content.title"),
        "close-title": _vm.$t("common.cancel"),
        "ok-title": _vm.$t("common.confirm"),
        "ok-busy": _vm.busy
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.reportContent()
        }
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "Radio",
            {
              attrs: {
                id: "option-content-has-error",
                "model-value": _vm.reportIssue,
                "check-value": 1
              },
              on: { change: _vm.onRadioSelect }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("common.modal.report_content.options.has_error")
                    ) +
                    "\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "Radio",
            {
              attrs: {
                id: "option-content-is-inappropriate",
                "model-value": _vm.reportIssue,
                "check-value": 2
              },
              on: { change: _vm.onRadioSelect }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "common.modal.report_content.options.inappropriate"
                      )
                    ) +
                    "\n      "
                )
              ])
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd431990", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd431990","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportContentModal.vue
// module id = Ospv
// module chunks = 1